<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import IconCart from '@/shared/components/UI/Icons/IconCart.vue';
import { useTranslations } from '@/shared/composables/useTranslations';
import { useCartStore } from '@/shared/pinia/modules/cart';

const props = defineProps<{
  initialItemCount: number;
}>();

const { t } = useTranslations();
const cartStore = useCartStore();
const { miniCartOpen } = storeToRefs(cartStore);

const openMiniCart = () => {
  cartStore.miniCartOpen = true;
};

const itemCount = computed(
  () => cartStore.cart?.item_count ?? props.initialItemCount
);
</script>

<template>
  <button
    type="button"
    class="js-mini-cart-icon relative flex flex-col items-center gap-px text-center text-base sm:text-base lg:gap-1"
    aria-haspopup="dialog"
    :aria-expanded="miniCartOpen"
    @click="openMiniCart"
  >
    <div class="relative">
      <IconCart
        class="text-xl text-white md:text-3xl lg:text-gray-darker"
        aria-hidden="true"
      />
      <span
        v-if="itemCount > 0"
        id="cartCount"
        class="absolute -right-3 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-pink p-1 text-xxs font-bold leading-none text-white lg:-right-3 lg:-top-3 lg:h-6 lg:min-w-6 lg:text-xs"
        aria-hidden="true"
      >
        {{ itemCount }}
      </span>
    </div>
    <span class="text-xxs text-white md:text-sm lg:text-gray-darkest">{{
      t('cart.basket')
    }}</span>
  </button>
</template>
